import { Button, FilterButton, Popover, SearchInput } from 'omakase';
import { ReactNode } from 'react';
import { SearchQueryStringParams } from 'components/search/utils';
import { Theme, css } from '@emotion/react';
import {
  popoverContent,
  popoverPaperRoot,
} from 'components/www/availability-search/searchBarAndButtonCssDefs';
// import { useSharedSearchBarStyles } from 'components/www/availability-search/SearchBarDesktop';

export const NO_SEARCH_UPDATES_SENTINEL = 'NO_SEARCH_UPDATES';

export type OnSearchType = (
  params: Partial<SearchQueryStringParams> | typeof NO_SEARCH_UPDATES_SENTINEL
) => void;
interface Props {
  qLabel: ReactNode;
  onClick(e: React.MouseEvent<HTMLButtonElement>): void;
  anchorEl: HTMLButtonElement | null;
  isOpen: boolean;
  onClose: () => void;
  q: string | string[] | undefined;
  onChangeQ: (q: string) => void;
  onSearch: OnSearchType;
}

export const twoActions = ({ spacing }: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: ${spacing(1.5)}px;
  & button:not(:last-child) {
    margin-right: theme.spacing(1);
  }
`;

const QuerySearchBarButton: React.FunctionComponent<Props> = ({
  qLabel,
  onClick,
  anchorEl,
  isOpen,
  onClose,
  onSearch,
  onChangeQ,
  q,
}) => {
  const flattendedQueryValue = typeof q === 'string' ? q : q?.toString();

  return (
    <>
      <FilterButton
        aria-haspopup
        aria-label="Edit search term"
        onClick={onClick}
        selected={!!qLabel}
        data-testid="search-term-edit-button"
      >
        {qLabel}
      </FilterButton>
      <Popover
        css={popoverPaperRoot}
        anchorEl={anchorEl}
        open={isOpen}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div css={popoverContent}>
          <form
            onSubmit={(event: React.FormEvent) => {
              event.preventDefault();
              onSearch(NO_SEARCH_UPDATES_SENTINEL);
            }}
          >
            <SearchInput
              placeholder="Search"
              size="medium"
              fullWidth
              name="q"
              id="q"
              value={flattendedQueryValue}
              onChange={(updatedValue: string) => onChangeQ(updatedValue)}
            />
            <div css={twoActions}>
              <Button
                size="small"
                variant="basic"
                onClick={() => {
                  onClose();
                  // Fully clears the query, runs the search again, updates the URL.
                  onSearch({
                    q: '',
                  });
                }}
                fullWidth
              >
                Clear
              </Button>
              <Button type="submit" size="small" variant="primary" fullWidth>
                Update search
              </Button>
            </div>
          </form>
        </div>
      </Popover>
    </>
  );
};

export default QuerySearchBarButton;
